<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="dialogRef.close()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>
  <h4 class="cg-dialog__header">Cigna Collaborative Accountable Care</h4>
  <div>
    <p>
      It is important to assign the Clinical Reports entitlement to users that
      need iCollaborate and/or CCC reporting access.
    </p>
    <p>
      After assigning access, send an email (CC your Value-Based Service
      Executive) to
      <a href="mailto:CCCReporting@Cigna.com">CCCReporting@Cigna.com</a> for
      access to performance repots and/or
      <a href="mailto:iCollaborateFeedback@Cigna.com"
        >iCollaborateFeedback@Cigna.com</a
      >
      for access to patient-actionable information.
    </p>
    <p>Include the following in your email:</p>
    <ul>
      <li>Full name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>The ACO TIN you used to register and name of ACO/Group</li>
      <li>
        User ID created for
        <a href="https://CignaforHCP.cigna.com">CignaforHCP.com</a> (do not
        include your password)
      </li>
      <li>
        Specify which role you are requesting (e.g. ECC and/or file upload
        administrator)
      </li>
    </ul>
  </div>
</div>
